import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: black;
  position: relative;
  align-items: center;
  justify-content: center;
`;

export const Video = styled.div`
  display: flex;
  align-items: center !important;
  width: 100%;
  height: 100vh;
  position: fixed;
  overflow: hidden;
  z-index: 1;
  top: 0;
  left: 0;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
